import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { HttpApiService } from '../../../../shared/services/base/http-api.service';
import { ValidationMessageService } from '../../../../shared/services/base/validation-message-handle';
import { MessageService } from 'primeng/api';
import { finalize } from 'rxjs/operators';
import { HttpErrorResponse } from '@angular/common/http';
import { SupplierModel } from '../../../../shared/entities/supplier.model';
import { SupplierService } from '../../../../shared/services/app/supplier.service';

@Component({
    selector: 'app-suppliers-add-edit',
    templateUrl: './suppliers-add-edit.component.html',
    styleUrls: ['./suppliers-add-edit.component.scss']
})
export class SuppliersAddEditComponent implements OnInit {

    public uid: string = null;
    public supplierModel: SupplierModel = new SupplierModel();
    public loading = false;
    public form: UntypedFormGroup;

    constructor(
        public ref: DynamicDialogRef,
        public config: DynamicDialogConfig,
        private formBuilder: UntypedFormBuilder,
        private httpApiService: HttpApiService,
        private validationMessageService: ValidationMessageService,
        private supplierService: SupplierService,
        private messageService: MessageService
    ) {
    }

    ngOnInit(): void {
        this.uid = (this.config.data) ? this.config.data.uid : null;

        this.createForm();

        if (this.uid) {
            this.getItem();
        }

        return;
    }

    onCloseDialog(supplier: SupplierModel) {
        this.ref.close(supplier);
    }


    createForm(): void {
        this.form = this.formBuilder.group({
            uid: [this.supplierModel.uid],
            code: [this.supplierModel.code, [Validators.required, Validators.maxLength(100)]],
            name: [this.supplierModel.name, [Validators.required, Validators.maxLength(200)]],
            uniqueCode: [this.supplierModel.uniqueCode, [Validators.required, Validators.maxLength(200)]],
            registrationNumber: [this.supplierModel.registrationNumber, [Validators.required, Validators.maxLength(200)]],
            address: [this.supplierModel.address, [Validators.required, Validators.maxLength(1000)]],
            email: [this.supplierModel.email, [Validators.required, Validators.maxLength(200), Validators.email]],
            phone: [this.supplierModel.phone, [Validators.required, Validators.maxLength(200)]],
            county_id: [this.supplierModel.county.id, Validators.required],
            city_id: [this.supplierModel.city.id, Validators.required],
            contacts: this.formBuilder.array([]),
            addresses: this.formBuilder.array([])
        });
    }

    getItem(): void {
        this.loading = true;
        this.supplierService.get(this.uid)
            .pipe(finalize(() => this.loading = false))
            .subscribe((response: any) => {
                this.supplierModel.map(response.payload);
                this.form.patchValue(this.supplierModel);
            });
    }


    onCancel(): void {
        this.ref.close(null);
    }

    checkIfFormValid(): boolean {
        if (this.form.invalid) {
            this.messageService.add({
                severity: 'error',
                summary: 'Formularul nu este valid!',
                detail: 'Vericficati toate campurile si incercati din nou.'
            });
            this.form.markAllAsTouched();
            return false;
        }
        return true;
    }

    onSave(): void {
        if (!this.checkIfFormValid()) {
            return;
        }
        this.loading = true;
        const data = this.form.getRawValue();
        if (data.addresses.length === 0) {
            delete (data.addresses);
        }
        if (data.contacts.length === 0) {
            delete (data.contacts);
        }
        this.supplierService.set(data)
            .pipe(finalize(() => this.loading = false))
            .subscribe((response: any) => {
                this.supplierModel.map(response.payload);
                this.form.patchValue(this.supplierModel);
                this.messageService.add({
                    severity: 'success',
                    summary: 'Furnizorul a fost salvat cu success!'
                });
                this.ref.close(this.supplierModel);
            }, err => {
                if (err instanceof HttpErrorResponse) {

                    this.validationMessageService.serverSideValidation(err, this.form, '', true);
                }
            });
    }
}
